module.exports = __webpack_public_path__ + "static/img/ct3.f1818de.jpg";